<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('scope.text_841')}}</div>
    <div slot="body">
      <a-form
        :form="form.fc"
        @submit="handleConfirm">
        <a-form-item
          :label="$t('scope.text_647')"
          v-bind="formItemLayout">
          <a-input-number
            v-decorator="decorators.money"
            :precision="2" />
        </a-form-item>
        <a-form-item
          :label="$t('scope.text_442')"
          v-bind="formItemLayout">
          {{ params.data.currency }}
        </a-form-item>
        <a-form-item
          :label="$t('scope.text_852')"
          v-bind="formItemLayout">
          <a-date-picker
            v-decorator="decorators.paid_at"
            format="YYYY-MM-DD HH:mm:ss"
            :disabled-date="disabledDate"
            :disabled-time="disabledDateTime"
            :show-time="{ defaultValue: $moment('00:00:00', 'HH:mm:ss') }" />
        </a-form-item>
        <a-form-item
          :label="$t('scope.text_827')"
          v-bind="formItemLayout">{{$t('scope.text_685')}}</a-form-item>
        <a-form-item
          :label="$t('scope.text_853')"
          v-bind="formItemLayout">
          <a-input v-decorator="decorators.source_id" />
        </a-form-item>
        <a-form-item
          :label="$t('scope.text_854')"
          v-bind="formItemLayout">
          <a-textarea
            v-decorator="decorators.note"
            :auto-size="{ minRows: 3, maxRows: 5 }" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-popconfirm
        :title="$t('scope.text_855')"
        ok-:text="$t('scope.text_856')"
        cancel-:text="$t('scope.text_456')"
        @confirm="handleConfirm">
        <a-button type="primary" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      </a-popconfirm>
      <a-button @click="cancelDialog">{{$t('scope.text_457')}}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapState } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'OfflineRechargeAmountDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this, {}),
      },
      formItemLayout: {
        wrapperCol: {
          span: 7,
        },
        labelCol: {
          span: 3,
        },
      },
      decorators: {
        money: [
          'money',
          {
            validateFirst: true,
            rules: [
              { required: true, message: this.$t('scope.text_857') },
              { validator: this.checkMoney },
            ],
          },
        ],
        paid_at: [
          'paid_at',
          {
            rules: [
              { required: true, message: this.$t('scope.text_858') },
            ],
          },
        ],
        source_id: [
          'source_id',
          {
            rules: [
              { required: true, message: this.$t('scope.text_859') },
            ],
          },
        ],
        note: [
          'note',
        ],
      },
    }
  },
  computed: {
    ...mapState('app', {
      customer: state => state.customer,
    }),
  },
  methods: {
    range (start, end) {
      const result = []
      for (let i = start; i < end; i++) {
        result.push(i)
      }
      return result
    },
    disabledDate (current) {
      return current && current > this.$moment().endOf('day')
    },
    disabledDateTime () {
      return {
        disabledHours: () => this.range(0, 24).splice(4, 20),
        disabledMinutes: () => this.range(30, 60),
        disabledSeconds: () => [55, 56],
      }
    },
    checkMoney (rule, value, callback) {
      if (value.toString().indexOf('-') >= 0) {
        const error = this.$t('scope.text_860')
        callback(error)
      } else {
        callback()
      }
    },
    doCreate (data) {
      return this.params.onManager('create', {
        managerArgs: {
          data,
        },
      })
    },
    async handleConfirm (e) {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        const data = {
          amount: values.money,
          billing_account_id: this.params.data.id,
          currency: this.params.data.currency,
          paid_at: this.$moment(values.paid_at).format('YYYY-MM-DD HH:mm:ss'),
          source_id: values.source_id,
          type: 'offline',
        }
        if (values.note) {
          data.extra = {
            note: values.note,
          }
        }
        await this.doCreate(data)
        this.cancelDialog()
        this.loading = false
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>

<style lang="less" scoped>
  .recharge-amount {
    .money {
      color: #4DA1FF;
    }
    .desc {
      font-size: 12px;
      line-height: 32px;
    }
    .pay-type {
      list-style: none;
      padding: 0;
      .pay-type-item {
        width: 860px;
        cursor: pointer;
        border-width: 1px;
        border-style: solid;
        border-color: rgb(215, 216, 217);
        border-image: initial;
        .radio-box {
          padding: 12px 16px;
          .radio {
            display: inline-block;
          }
          .radio-text {
            display: inline-block;
            vertical-align: top;
            font-size: 18px;
            .ali-icon {
              font-size: 22px;
            }
          }
        }
      }
      .pay-type-current {
        border-width: 2px;
        border-style: solid;
        border-color: rgb(255, 166, 0);
        border-image: initial;
      }
    }
    ::v-deep {
      .ant-checkbox-wrapper {
        color: rgb(115, 119, 122);
        font-size: 14px;
      }
      .ant-form-item {
        margin-bottom: 0;
        .ant-input-number {
          width: 100%;
        }
      }
    }
  }
</style>
